import { Flex, Text } from "@gravity-ui/uikit";

import css from "./TemplateEditor.module.scss";
import type { UnknownVariableRange } from "./TemplateEditor.utils";

interface Props {
  ranges: UnknownVariableRange[];
  id?: string;
  onApplySuggestion: (path: string, suggestion: string) => void;
}

// Блок под редактором: для каждой неизвестной переменной — её имя и кнопка
// did-you-mean (если backend прислал suggestion). Без suggestion рисуем
// серую плашку «нет подсказки» — кейс для namespace-полей типа `__proto__`,
// которые backend намеренно не суджестит.
export const UnknownVariableList = ({
  ranges,
  id,
  onApplySuggestion,
}: Props) => {
  if (ranges.length === 0) return null;

  return (
    <div id={id} className={css.unknownList} role="alert">
      <Text variant="body-2" color="danger">
        Неизвестные переменные:
      </Text>
      <Flex gap={2} wrap>
        {ranges.map((u, idx) => (
          <div key={`${u.path}-${idx}`} className={css.unknownRow}>
            <code className={css.unknownPath}>{`{{${u.path}}}`}</code>
            {u.suggestion ? (
              <button
                type="button"
                className={css.suggestionBtn}
                onClick={() => onApplySuggestion(u.path, u.suggestion ?? "")}
              >
                Заменить на <code>{`{{${u.suggestion}}}`}</code>
              </button>
            ) : (
              <span className={css.noSuggestion}>нет подсказки</span>
            )}
          </div>
        ))}
      </Flex>
    </div>
  );
};
